module.exports = __webpack_public_path__ + "static/media/mercado-modelo-calendario-ima.453774df.jpg";